import { RouteRecordRaw } from 'vue-router';
import AppDownload from '@/components/mobile/pages/app-download.vue';
import redirectEmailPage from '@/components/redirect-page/email.vue';

export const mobileRoutes: RouteRecordRaw[] = [
  // メールから記事を開く際にユーザーのメーラーが、
  // 計測用エンドポイントにアクセスすることを防ぐためにクッションページを挟む
  {
    path: '/r/:docType/:articleId',
    component: redirectEmailPage,
    name: 'redirect_page',
    meta: {
      type: 'no_login_required_redirect',
      accessScope: 'public',
    },
  },
  // 特定の環境でemailからリンクをタップしてもモバイルアプリに遷移しない暫定対応
  // NOTE: https://stockmarkteam.slack.com/archives/C02FEP5DPFW/p1758845348640289?thread_ts=1755759355.434439&cid=C02FEP5DPFW
  {
    path: '/articles/:id',
    component: () => import('@/components/mobile/pages/adp-document.vue'),
    name: 'articlePage',
    meta: { title: '記事詳細', accessScope: 'information_retrieval' },
    props: route => ({
      id: route.params.id,
      doc_type: 'article',
    }),
  },
  {
    path: '/mobile_login',
    component: () => import('@/components/account/mobile-login.vue'),
    name: 'login',
    meta: { title: 'ログイン', type: 'account', accessScope: 'public' },
  },
  {
    path: '/account',
    component: () => import('@/components/layouts/mobile-account.vue'),
    meta: { accessScope: 'public' },
    children: [
      {
        path: 'saml/login',
        component: () => import('@/components/account/saml-login.vue'),
        name: 'samlLogin',
        meta: { title: 'SSOログイン', type: 'account' },
      },
      {
        path: 'saml/callback',
        component: () => import('@/components/account/saml-callback.vue'),
        name: 'samlCallback',
        meta: { title: 'SSOログイン', type: 'account' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)',
    component: AppDownload,
    meta: { accessScope: 'public' },
  },
];
